module.exports = __webpack_public_path__ + "img/search.6e626237.svg";